import { useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { Header } from '../components/Header.jsx'
import { NoProjectView } from './NoProjectView'
import projectsData from '../data/projects.json'

export const ProjectView = () => {
  const [imageIndex, setImageIndex] = useState(0)
  const { slug } = useParams()
  const navigate = useNavigate()

  useEffect(() => {
    setImageIndex(0)
  }, [slug])

  const selectedProjectIndex = projectsData.data.findIndex(
    (item) => item.slug === slug
  )
  const selectedProject = projectsData.data[selectedProjectIndex]

  if (!selectedProject) {
    return <NoProjectView />
  }

  const changeSlide = (operation) => {
    if (operation === '+') {
      const newIndex = imageIndex + 1
      if (newIndex > selectedProject.screenshots.length - 1) {
        setImageIndex(0)
      } else {
        setImageIndex(newIndex)
      }
    } else if (operation === '-') {
      const newIndex = imageIndex - 1
      if (newIndex < 0) {
        setImageIndex(selectedProject.screenshots.length - 1)
      } else {
        setImageIndex(newIndex)
      }
    }
  }

  let nextProjectId = projectsData.data.findIndex(
    (_item, index) => index === selectedProjectIndex + 1
  )

  let prevProjectId = projectsData.data.findIndex(
    (_item, index) => index === selectedProjectIndex - 1
  )

  if (prevProjectId === -1) prevProjectId = projectsData.data.length - 1
  if (nextProjectId === -1) nextProjectId = 0

  return (
    <>
      {selectedProject && (
        <>
          <Header
            title={selectedProject.name}
            description={selectedProject.description}
          />
          <div className='project_container'>
            {!!selectedProject.screenshots.length && (
              <div className='project_carousel'>
                <span
                  className='material-symbols-rounded'
                  onClick={() => changeSlide('-')}>
                  keyboard_arrow_left
                </span>
                <img
                  src={selectedProject.screenshots[imageIndex]}
                  alt={`Screenshot ${imageIndex + 1}: ${selectedProject.name}`}
                />
                <span
                  className='material-symbols-rounded'
                  onClick={() => changeSlide('+')}>
                  keyboard_arrow_right
                </span>
              </div>
            )}
            <a
              href={selectedProject.sourceLink}
              target='_blank'
              rel='noopener noreferrer'
              className='icon_grid'>
              <span className='material-symbols-rounded'>code</span>
              <span>Source code</span>
            </a>
            {!!selectedProject.content.length && (
              <section className='project_content'>
                {selectedProject.content.map((item, index) => (
                  <div key={index}>
                    <h3>{item.title}</h3>
                    <p>{item.text}</p>
                  </div>
                ))}
              </section>
            )}
            <div className='project_date'>
              <b>Published:</b>
              <span>{selectedProject.year}</span>
            </div>
            <div className='project_nav'>
              <div
                onClick={() =>
                  navigate(
                    `/index/projects/${projectsData.data[nextProjectId].slug}`,
                    { replace: true }
                  )
                }>
                <h3>
                  Next project &gt;&gt;{' '}
                  <em>{projectsData.data[nextProjectId].name}</em>
                </h3>
              </div>
              <div
                onClick={() =>
                  navigate(
                    `/index/projects/${projectsData.data[prevProjectId].slug}`,
                    { replace: true }
                  )
                }>
                <h3>
                  <em>{projectsData.data[prevProjectId].name}</em> &lt;&lt;
                  Previous project
                </h3>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  )
}
